import { render } from "./optional_router_link.vue?vue&type=template&id=0ec30c00"
import script from "./optional_router_link.vue?vue&type=script&lang=js"
export * from "./optional_router_link.vue?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__